import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { RegexConstants } from '@wz-constants';
import { Tarif } from '@wz-models';
import { LoggerService } from '@wz-services';
import { formatDate } from '@wz-utilities/date.utilities';
import * as CryptoJS from 'crypto-js';
import { AdresseNewApiService } from 'libs/modules/tunnelsante/services/api/adresse-new-api.service';
import { SouscriptionEnLigneApiService } from 'libs/modules/tunnelsante/services/api/souscription-en-ligne-api.service';
import { NumeroInseeService } from 'libs/modules/tunnelsante/services/numero-insee.service';
import { ValiderData } from 'models/valider-data.models';
import { Subscription } from 'rxjs/internal/Subscription';
import { Enfant } from '../../insurances/devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../../insurances/devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../../insurances/devis-formulaire/Models/Personne';
import { MyDataService } from '../../insurances/services/my-data.service';
import { TaggingService } from '../../insurances/services/tagging.service';
import { Adresse } from '../models/Adresse.model';
import {
  AssureConjoint,
  AssureEnfant,
  AssurePrincipal,
  Assurees,
} from '../models/Assurees.model';
import { Souscription } from '../models/Souscription.model';
import { ValueSubscribe } from '../models/tarif-view-model.model';
import { OriginThemeService } from '../originThemeService';
import { Guid_Mdp } from '../souscription-en-ligne/souscription-en-ligne.component';

@Component({
  selector: 'wz-souscription-coordonnees',
  templateUrl: './souscription-coordonnees.component.html',
  styleUrls: ['./souscription-coordonnees.component.scss'],
  standalone: false,
})
export class SouscriptionCoordonneesComponent implements OnInit {
  errorFraude: boolean = false;
  @Input() public personne!: Personne;
  subscription: Subscription = new Subscription();
  @Input() enfant: Enfant = new Enfant(0, []);
  @Input() niveauRemboursement: NiveauRemboursement = new NiveauRemboursement(
    '',
    '',
    '',
    '',
    '',
  );
  situationFamiliale!: string | null;
  displayconjoint: boolean = false;
  displayEnfant: boolean = false;

  public DateNaissanceMin!: Date;
  public formatDateNaissanceMin!: string | null;
  public DateNaissanceMax!: Date;
  public formatDateNaissanceMax!: string | null;
  dateDuJour!: Date;
  dateDuJourNaissance!: Date;
  dateDuJourEffet!: Date;

  @Output() validerEvent = new EventEmitter();
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventSouscriptionEmitter: EventEmitter<any> =
    new EventEmitter<any>();
  //Mat tab Index:
  @Input() selectedIndex: number = 0;
  assuree!: Assurees;
  souscription!: Souscription;
  assurePrinc!: AssurePrincipal;
  assureConjoint!: AssureConjoint | null;
  assureEnfant: AssureEnfant[] = [];
  numeroSsEnfant!: string;
  cspEnfant!: string;

  loadData: boolean = false;

  //assurePrincipal : Assurees.AssurePrincipal;
  numSecuSocial: string = '';
  paysNaissance: string = '';
  paysNaissanceConjoint: string = '';
  lieuNaissance: string = '';
  lieuNaissanceConjoint: string = '';
  addWaringAddress: string = '';
  addWaringPostalCode: string = '';
  addWaringVille: string = '';

  paysLieuNaissanceData: any = {};

  adressePostale: string = '';
  complementAdresse: string = '';
  codeOrganisme: string = '';
  ville: string = '';
  guid_mdp!: Guid_Mdp;
  @Input() GUID: string = '';
  @Input() MDP: string = '';
  dateNaissance!: Date;
  // jAccepte: boolean = false;
  assureEnfantItem!: AssureEnfant;
  ayantDroitVia: string = '1';
  isCheckedAyantDroit: boolean = true;
  noOrga: boolean = false;
  regimeSocialSouscripteur: string = '';
  //Date pattern:
  datePattern: string =
    '(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))';
  secuPattern: string =
    '[12][ \.\-]?[0-9]{2}[ \.\-]?(0[1-9]|[1][0-2])[ \.\-]?([0-9]{2}|2A|2B)[ \.\-]?[0-9]{3}[ \.\-]?[0-9]{3}[ \.\-]?[0-9]{2}';
  emailPattern: string = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';
  codeOrganismePattern: string = '[0-9]{2}[ \.\-]?[0-9]{3}[ \.\-]?[0-9]{4}';
  //Control Validator:

  phoneControl!: FormControl;
  nomCtrl!: FormControl;
  prenomCtrl!: FormControl;
  professionCtrl!: FormControl;
  cspCtrl!: FormControl;
  secuCtrl!: FormControl;
  paysCtrl!: FormControl;
  paysConjointCtrl!: FormControl;
  emailCtrl!: FormControl;
  codeParrainCtrl!: FormControl;
  adressePostaleCtrl!: FormControl;
  villeCtrl!: FormControl;
  caisseCtrl!: FormControl;
  nomConjointCtrl!: FormControl;
  prenomConjointCtrl!: FormControl;
  secuConjointCtrl!: FormControl;
  cspConjointCtrl!: FormControl;
  caisseConjointCtrl!: FormControl;
  codePostaleCtrl!: FormControl;
  //codeOrganismeCtrl !: FormControl;

  formulaireFormGroup!: FormGroup;
  isConjoint: boolean = false;

  validationEtape1: boolean = false;
  loading: boolean = false;
  ayantDroitVotreConjoit: boolean = false;
  @Output() validationEtape1Event: EventEmitter<any> = new EventEmitter();

  //CSP:
  listeCsp: string[] = [
    'Agriculteur',
    'Artisan',
    'Auto entrepreneur',
    "Chef d'entreprise",
    'Commercant',
    "Demandeur d'emploi",
    'Etudiant',
    'Fonction publique',
    'Int. du spectacle',
    'Militaire',
    'Ouvrier',
    'Profession libérale',
    'Retraité',
    'Salarié cadre',
    'Salarié non cadre',
    'Sans profession',
  ];

  //Tagging
  VisiteurId!: string;
  villeExist: boolean = false;

  constructor(
    private myDataService: MyDataService,
    private formBuilder: FormBuilder,
    private souscriptionApi: SouscriptionEnLigneApiService,
    private numeroInseeService: NumeroInseeService,
    private adresseApi: AdresseNewApiService,
    private taggingService: TaggingService,
    private originThemeService: OriginThemeService,
    private router: Router,
    private loggerService: LoggerService,
  ) {
    this.nomCtrl = this.formBuilder.control({ value: '', disabled: true }, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.prenomCtrl = this.formBuilder.control({ value: '', disabled: true }, [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.phoneControl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(RegexConstants.AllPhone),
      Validators.maxLength(13),
      Validators.minLength(10),
    ]);
    this.professionCtrl = this.formBuilder.control('', [Validators.required]);
    this.cspCtrl = this.formBuilder.control('', Validators.required);
    this.secuCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.minLength(15),
      Validators.maxLength(15),
      Validators.pattern(this.secuPattern),
    ]);
    this.paysCtrl = this.formBuilder.control('', Validators.required);
    this.emailCtrl = this.formBuilder.control({ value: '', disabled: true }, [
      Validators.required,
      Validators.pattern(this.emailPattern),
    ]);
    this.codeParrainCtrl = this.formBuilder.control('', []);
    this.adressePostaleCtrl = new FormControl('', [
      Validators.required,
      this.compareAdresseParrainValidator().bind(this),
    ]);
    this.villeCtrl = this.formBuilder.control('', [
      Validators.required,
      this.compareAdresseParrainValidator().bind(this),
    ]);
    this.caisseCtrl = this.formBuilder.control('', [
      Validators.minLength(9),
      Validators.maxLength(9),
      Validators.pattern(this.codeOrganismePattern),
    ]);
    this.nomConjointCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.prenomConjointCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.pattern(RegexConstants.Name),
    ]);
    this.secuConjointCtrl = this.formBuilder.control('', [
      Validators.required,
      Validators.minLength(15),
      Validators.maxLength(15),
      Validators.pattern(this.secuPattern),
    ]);
    this.cspConjointCtrl = this.formBuilder.control('', [
      Validators.required,
      this.compareAdresseParrainValidator().bind(this),
    ]);
    this.paysConjointCtrl = this.formBuilder.control('', Validators.required);
    this.caisseConjointCtrl = this.formBuilder.control('', [
      Validators.minLength(9),
      Validators.maxLength(9),
      Validators.pattern(this.codeOrganismePattern),
    ]);
    this.codePostaleCtrl = this.formBuilder.control(
      { value: '', disabled: true },
      [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5),
        Validators.pattern(RegexConstants.POSTAL_CODE),
      ],
    );

    //this.codeOrganismeCtrl = new FormControl('', Validators.required)
    this.formulaireFormGroup = new FormGroup({
      //name: "",
      nomCtrl: this.nomCtrl,
      prenomCtrl: this.prenomCtrl,
      professionCtrl: this.professionCtrl,
      dateNaissanceEnfant: this.formBuilder.array([]),
      cspCtrl: this.cspCtrl,
      secuCtrl: this.secuCtrl,
      paysCtrl: this.paysCtrl,
      phoneControl: this.phoneControl,
      emailCtrl: this.emailCtrl,
      codeParrainCtrl: this.codeParrainCtrl,
      adressePostaleCtrl: this.adressePostaleCtrl,
      villeCtrl: this.villeCtrl,
      caisseCtrl: this.caisseCtrl,
      conjoint: this.formBuilder.array([]),
      codePostaleCtrl: this.codePostaleCtrl,
    });

    this.paysLieuNaissanceData = {
      lieuNaissance: this.lieuNaissance,
      lieuNaissanceConjoint: this.lieuNaissanceConjoint,
      paysNaissance: this.paysNaissance,
      paysNaissanceConjoint: this.paysNaissanceConjoint,
      enfants: [],
    };
  }

  compareAdresseParrainValidator(): ValidatorFn {
    let value = sessionStorage.getItem('app.personne');
    let personne!: Personne;

    let postalCodeParrain = '';
    let villeParrain = '';
    if (value) {
      //Set Personne modele
      personne = JSON.parse(value);
      let parameter_parrain = localStorage.getItem('parrain');

      if (parameter_parrain) {
        let address1_parrain: any = localStorage.getItem('address1_parrain');
        let address2_parrain: any = localStorage.getItem('address2_parrain');
        let postalcodeville: any = localStorage.getItem('postalcodeville');

        if (postalcodeville) {
          let info = postalcodeville.split('@@@');
          if (info.length > 1) {
            postalCodeParrain = postalcodeville.split('@@@')[0];
            villeParrain = postalcodeville.split('@@@')[1];
          }
        }

        personne.adresse1Parrain = address1_parrain;
        personne.adresse2Parrain = address2_parrain;

        sessionStorage.setItem('app.personne', JSON.stringify(personne));
      }
    }

    let active: boolean = false;
    let address1: string | null = null;
    let address2: string | null = null;
    let postalCode: string | null = null;

    if (!!personne) {
      active = !!personne.codeParrain;
      address1 = personne.adresse1Parrain;
      address2 = personne.adresse2Parrain;
      postalCode = personne.codePostal;
    }

    return (control: AbstractControl): ValidationErrors | null => {
      if (!active || (address1 == '' && address2 == '')) {
        return null; // Validation passed
      }

      if (
        active &&
        control.value.toLocaleLowerCase() !== address1?.toLocaleLowerCase()
      ) {
        if (
          postalCode &&
          postalCode.toLocaleLowerCase() ==
            postalCodeParrain.toLocaleLowerCase()
        ) {
          this.addWaringPostalCode =
            'Vérifier le code postal, le code postal saisi est le même que celui du parrain.';
        } else {
          this.addWaringPostalCode = '';
        }

        if (
          (control.value &&
            control.value.toLocaleLowerCase() ==
              villeParrain.toLocaleLowerCase()) ||
          (control.value &&
            this.ville.toLocaleLowerCase() == villeParrain.toLocaleLowerCase())
        ) {
          this.addWaringVille =
            'Vérifier la ville, la ville sélectionnée est la même que celle du parrain.';
        } else {
          this.addWaringVille = '';
        }

        return null; // Validation passed
      } else {
        this.addWaringAddress =
          "Vérifier l'adresse, l'adresse saisie est la même que celle du parrain.";

        if (postalCode && postalCode.toLocaleLowerCase() == postalCode) {
          this.addWaringPostalCode =
            'Vérifier le code postal, le code postal saisie est le même que celui du parrain.';
        }

        return null; // Validation passed
      }
    };
  }

  leadTag = '';
  @Input() tarif!: Tarif;

  ngOnInit() {
    this.subscription = this.myDataService.currentData.subscribe(
      (message: Personne) => {
        this.personne = message;
      },
    );
    //this.personne = new Personne("", "", "", "", "", "", "", "", this.enfant, "", this.niveauRemboursement, "", "", "", false);

    this.themeParams();

    const valuePersonne = sessionStorage.getItem('app.personne');
    const valueLead = sessionStorage.getItem('app.lead');
    const valueTarif = sessionStorage.getItem('app.produittarif');

    if (valueLead) {
      this.leadTag = JSON.parse(valueLead);
    } else this.leadTag = 'comparateurs';

    if (valueTarif) {
      this.tarif = JSON.parse(valueTarif);
    }

    if (valuePersonne) {
      this.personne = JSON.parse(valuePersonne);

      this.regimeSocialSouscripteur = this.personne.regimeSocial;
    }
    this.paysLieuNaissanceData = {
      lieuNaissance: this.lieuNaissance,
      lieuNaissanceConjoint: this.lieuNaissanceConjoint,
      paysNaissance: this.paysNaissance,
      paysNaissanceConjoint: this.paysNaissanceConjoint,
      enfants: [],
    };

    // restore pays/lieu naissance
    const valuePaysLieuNaissance = sessionStorage.getItem(
      'save.paysLieuNaissance',
    );
    if (valuePaysLieuNaissance) {
      let savedPaysLieuNaissance = JSON.parse(valuePaysLieuNaissance);
      this.paysLieuNaissanceData = savedPaysLieuNaissance;
      ({
        lieuNaissance: this.lieuNaissance,
        lieuNaissanceConjoint: this.lieuNaissanceConjoint,
        paysNaissance: this.paysNaissance,
        paysNaissanceConjoint: this.paysNaissanceConjoint,
      } = savedPaysLieuNaissance);
    }

    const valueSouscription = sessionStorage.getItem('save.souscription');
    if (valueSouscription) {
      this.souscription = JSON.parse(valueSouscription);
      if (!this.souscription.adresseSouscripteur)
        this.souscription.adresseSouscripteur = '';
      this.lieuNaissance = this.souscription.lieuNaissanceSouscripteur;
      this.paysLieuNaissanceData = {
        ...this.paysLieuNaissanceData,
        lieuNaissance: this.lieuNaissance,
      };
    }
    const valueAssuree = sessionStorage.getItem('save.assuree');
    if (valueAssuree) {
      this.assuree = JSON.parse(valueAssuree);
      this.paysNaissance = this.assuree.paysNaissance;
    }

    this.situationFamiliale = this.personne.compositionFamiliale;

    //Pas de conjoint et pas d'enfant:
    if (this.situationFamiliale == '1') {
      this.isConjoint = false;
      this.displayconjoint = false;
      this.displayEnfant = false;
      this.assureConjoint = null;
    }
    //Pas de conjoint mais avec enfants:
    if (this.situationFamiliale == '2') {
      this.isConjoint = false;
      this.displayconjoint = false;
      this.assureConjoint = null;
      this.displayEnfant = true;
    }

    //Avec conjoint sans enfants
    if (this.situationFamiliale == '3') {
      //Add control conjoint
      this.conjoint().push(this.new_conjoint_control());

      this.displayconjoint = true;
      this.isConjoint = true;
      this.displayEnfant = false;
      this.initializeConjoint();
    }
    //Avec conjoint et avec enfants
    if (this.situationFamiliale == '4') {
      //Add control conjoint
      this.conjoint().push(this.new_conjoint_control());

      this.displayconjoint = true;
      this.isConjoint = true;
      this.displayEnfant = true;
      this.initializeConjoint();
    }

    //Avec enfants
    if (this.situationFamiliale == '2' || this.situationFamiliale == '4') {
      this.displayEnfant = true;
      //if valueAssuree exists in Session storage:
      if (valueAssuree) {
        //Initialize Enfants from sessionStorage:
        for (
          let i = 0;
          i < this.personne.enfant.dateNaissanceEnfant.length;
          i++
        ) {
          let date = this.personne.enfant.dateNaissanceEnfant[i];
          this.dateNaissanceEnfant().push(this.new_enfant('', '', date)); //creating input dateNaissance

          let enfantItem: AssureEnfant = {
            sexe: this.assuree.assureEnfants[i].sexe,
            nom: this.assuree.assureEnfants[i].nom,
            prenom: this.assuree.assureEnfants[i].prenom,
            dateNaissance: this.assuree.assureEnfants[i].dateNaissance,
            csp: this.assuree.assureEnfants[i].csp,
            regime: this.assuree.assureEnfants[i].regime,
            num_SS: this.assuree.assureEnfants[i].num_SS,
            orga: this.assuree.assureEnfants[i].orga,
            noOrga: this.assuree.assureEnfants[i].noOrga,
            rang: i + 1,
            ayantDroit: this.assuree.assureEnfants[i].ayantDroit,
            ayantDroitDe: this.assuree.assureEnfants[i].ayantDroitDe,
          };
          this.paysLieuNaissanceData['enfants'] = {
            ...this.paysLieuNaissanceData['enfants'],
            [i]: {
              ...this.paysLieuNaissanceData['enfants'][i],
              paysNaissance:
                this.paysLieuNaissanceData['enfants'][i] &&
                this.paysLieuNaissanceData['enfants'][i].paysNaissance
                  ? this.paysLieuNaissanceData['enfants'][i].paysNaissance
                  : '',
              lieuNaissance:
                this.paysLieuNaissanceData['enfants'][i] &&
                this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                  ? this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                  : '',
            },
          };

          //Add Item
          this.assureEnfant.push(enfantItem);
        }
      } else {
        //Initialize Enfants with default value:
        for (
          let i = 0;
          i < this.personne.enfant.dateNaissanceEnfant.length;
          i++
        ) {
          let date = this.personne.enfant.dateNaissanceEnfant[i];

          this.dateNaissanceEnfant().push(this.new_enfant('', '', date)); //creating control on input dateNaissance
          //Fill AssureEnfantModel:
          let enfantItem: AssureEnfant = {
            sexe: '1',
            nom: '',
            prenom: '',
            dateNaissance: date,
            csp: '',
            regime: '',
            num_SS: '',
            orga: '',
            noOrga: false,
            rang: 1,
            ayantDroit: true,
            ayantDroitDe: '',
          };

          this.paysLieuNaissanceData['enfants'] = {
            ...this.paysLieuNaissanceData['enfants'],
            [i]: {
              ...this.paysLieuNaissanceData['enfants'][i],
              paysNaissance:
                this.paysLieuNaissanceData['enfants'][i] &&
                this.paysLieuNaissanceData['enfants'][i].paysNaissance
                  ? this.paysLieuNaissanceData['enfants'][i].paysNaissance
                  : '',
              lieuNaissance:
                this.paysLieuNaissanceData['enfants'][i] &&
                this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                  ? this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                  : '',
            },
          };

          //Add Item
          this.assureEnfant.push(enfantItem);
        }
      }
    }

    this.Initialized();

    //Get list de tous les villes:
    if (this.personne.codePostal) {
      this.villeExist = true;
      this.getListVilleByCP(this.personne.codePostal);
    }

    this.assuree.assurePrincipal.noOrga = false;
    this.regimeSocialSouscripteur = this.RegimeSocialSouscripteur(
      this.personne.regimeSocial,
    );

    //****Tagging*****
    //Exécute le tagging quand le leadTag ne vient pas de comparateurs
    this.VisiteurId = this.taggingService.checkVisiteurId();
    let sha256Mail = '';

    if (this.personne && this.tarif && this.leadTag != 'comparateurs') {
      if (this.personne.email) {
        sha256Mail = CryptoJS.SHA256(this.personne.email).toString(
          CryptoJS.enc.Hex,
        );
      }

      if (window['tc_vars'] && window['tC'] && this.selectedIndex == 0) {
        this.taggingService.refreshSouscription(
          '1',
          'vos coordonnees',
          this.VisiteurId,
          sha256Mail,
          this.leadTag,
          this.tarif,
        );
      }
    }
    this.onClickAyantDroit();

    this.formulaireFormGroup.patchValue({
      nomCtrl: this.personne.nom,
      prenomCtrl: this.personne.prenom,
    });
  }

  ngOnChanges(): void {
    this.VisiteurId = this.taggingService.checkVisiteurId();

    let sha256Mail = '';

    if (this.personne && this.tarif) {
      if (this.personne.email) {
        sha256Mail = CryptoJS.SHA256(this.personne.email).toString(
          CryptoJS.enc.Hex,
        );
      }

      if (window['tc_vars'] && window['tC'] && this.selectedIndex == 0) {
        this.taggingService.refreshSouscription(
          '1',
          'vos coordonnees',
          this.VisiteurId,
          sha256Mail,
          this.leadTag,
          this.tarif,
        );
      }

      this.onClickAyantDroit();
    }
  }
  //Control Conjoint:-------------------------------------------------------------
  conjoint() {
    return this.formulaireFormGroup.get('conjoint') as FormArray;
  }
  new_conjoint_control() {
    return this.formBuilder.group({
      nomConjointCtrl: this.nomConjointCtrl,
      prenomConjointCtrl: this.prenomConjointCtrl,
      secuConjointCtrl: this.secuConjointCtrl,
      cspConjointCtrl: this.cspConjointCtrl,
      caisseConjointCtrl: this.caisseConjointCtrl,
      paysConjointCtrl: this.paysConjointCtrl,
    });
  }
  RegimeSocialEnfant(situation: string, regimeEnfant: string): void {
    if (situation == '4') {
      if (
        this.personne.regimeSocial == '0' ||
        this.personne.conjointRegimeSociale == '1'
      ) {
        regimeEnfant = this.personne.regimeSocial;
      } else if (
        this.personne.regimeSocial == '1' ||
        this.personne.conjointRegimeSociale == '1'
      ) {
        regimeEnfant = this.personne.regimeSocial;
      } else if (
        this.personne.regimeSocial == '2' ||
        this.personne.conjointRegimeSociale == '2'
      ) {
        regimeEnfant = '0';
      } else if (
        this.personne.regimeSocial == '3' ||
        this.personne.conjointRegimeSociale == '3'
      ) {
        regimeEnfant = this.personne.regimeSocial;
      }
    } else if (this.personne.compositionFamiliale == '2') {
      regimeEnfant = this.personne.regimeSocial;
    } else {
      regimeEnfant = '';
    }
  }
  //Initialiser Conjoint:
  initializeConjoint() {
    this.assureConjoint = {
      sexe: '1',
      nom: '',
      prenom: '',
      dateNaissance: this.personne.dateNaissanceConjoint,
      csp: '',
      regime: this.personne.conjointRegimeSociale,
      num_SS: '',
      orga: '',
      noOrga: false,
    };
  }

  Initialized() {
    this.assurePrinc = {
      sexe: this.personne.sexe,
      nom: this.personne.nom,
      prenom: this.personne.prenom,
      dateNaissance: this.personne.dateNaissanceAssure,
      csp: '',
      regime: this.personne.regimeSocial,
      num_SS: '',
      orga: '',
      noOrga: false,
    };
    this.ControlDate();

    this.guid_mdp = {
      guid: this.GUID,
      mdp: this.MDP,
    };
    this.dateNaissance = new Date(this.personne.dateNaissanceAssure);

    //Initialize Assuree
    this.assuree = new Assurees(
      this.assurePrinc,
      this.isConjoint,
      this.assureConjoint,
      this.displayEnfant,
      this.assureEnfant,
      this.personne.dateDebutContrat,
      '',
      '',
      '',
      this.GUID,
      this.MDP,
      this.ville,
      this.adressePostale,
      this.complementAdresse,
    );
    this.souscription = new Souscription(
      this.personne.sexe,
      this.personne.nom,
      this.personne.prenom,
      this.personne.nom,
      this.dateNaissance,
      '',
      '',
      this.adressePostale,
      this.complementAdresse,
      this.personne.codePostal,
      this.ville,
      this.personne.email,
      this.personne.telephone,
      this.personne.telephone,
      false,
      this.personne.telephone,
      this.personne.email,
      '',
      '',
    );

    //Get values in sessionStorage:
    var getSessionSouscription = sessionStorage.getItem('save.souscription');
    if (getSessionSouscription) {
      this.souscription = JSON.parse(getSessionSouscription);
      this.ville = this.souscription.ville;
      // this.jAccepte = this.souscription.bAccepteCondition;
      this.complementAdresse = this.souscription.adresseComplementSouscripteur;
      this.adressePostale = this.souscription.adresseSouscripteur;
      this.paysNaissance = this.souscription.paysNaissanceSouscripteur;
    }
    var getSessionAssure = sessionStorage.getItem('save.assuree');
    if (getSessionAssure) {
      this.assuree = JSON.parse(getSessionAssure);
      this.numSecuSocial = this.assuree.assurePrincipal.num_SS;
      this.ville = this.assuree.ville;
      this.noOrga = this.assuree.assurePrincipal.noOrga;
      this.codeOrganisme = this.assuree.assurePrincipal.orga;
    }
    this.displayVotreConjoint();
  }

  errorMessage: any;
  telephoneInvalide() {
    //Numeros inexistants
    var validation = ValiderData.ValiderTelephone(this.personne.telephone);
    if (validation) this.errorMessage = validation;
    return validation;
  }

  //Emails invalides @test.fr
  emailInvalide(email: string): boolean {
    const value = email.toLowerCase();
    if (value.includes('@test')) {
      return true;
    } else {
      return false;
    }
  }

  //Enfants:
  dateNaissanceEnfant() {
    return this.formulaireFormGroup.get('dateNaissanceEnfant') as FormArray;
  }

  new_enfant(nom: string, prenom: string, date: string) {
    return this.formBuilder.group({
      nom_ctrl: new FormControl(nom, [
        Validators.required,
        Validators.pattern(RegexConstants.Name),
      ]),
      prenom_ctrl: new FormControl(prenom, [
        Validators.required,
        Validators.pattern(RegexConstants.Name),
      ]),
      date_enfant_ctrl: new FormControl({ value: date, disabled: true }, [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern(this.datePattern),
      ]),
      paysEnfantCtrl: new FormControl('', Validators.required),
    });
  }
  //AGE Enfants:
  checkChild18(idChild: any) {
    if (!this.personne.enfant.dateNaissanceEnfant[idChild]) return false;
    var dateNaissance = new Date(
      this.personne.enfant.dateNaissanceEnfant[idChild],
    );
    var dateNow = new Date();
    var diff = dateNow.getTime() - dateNaissance.getTime();
    var diffYear = diff / (1000 * 3600 * 24 * 365);
    if (diffYear >= 18 && diffYear <= 26) {
      return true;
    } else {
      return false;
    }
  }
  checkChild26(idChild: any) {
    if (!this.personne.enfant.dateNaissanceEnfant[idChild]) return false;
    var dateNaissance = new Date(
      this.personne.enfant.dateNaissanceEnfant[idChild],
    );
    var dateNow = new Date();
    var diff = dateNow.getTime() - dateNaissance.getTime();
    var diffYear = diff / (1000 * 3600 * 24 * 365);
    if (diffYear >= 26) {
      return true;
    } else {
      return false;
    }
  }
  checkChild(idChild: any) {
    var dateNaissance = new Date(
      this.personne.enfant.dateNaissanceEnfant[idChild],
    );
    var dateNow = new Date();
    this.loggerService.log('date naissance' + dateNaissance);
    this.loggerService.log('date ajd' + dateNow);
    if (dateNaissance > dateNow) {
      this.loggerService.log("date naissance apres aujourd'hui");
      return false;
    } else {
      return true;
    }
  }
  public ControlDate() {
    this.dateDuJour = new Date();
    this.dateDuJourNaissance = new Date(
      this.dateDuJour.getFullYear() - 55,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.dateDuJourEffet = new Date(
      this.dateDuJour.getFullYear(),
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate() + 2,
    );
    //this.dateNaissanceCtrl = this.fb.control('');
    this.DateNaissanceMin = new Date(
      this.dateDuJour.getFullYear() - 90,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.formatDateNaissanceMin = formatDate(
      this.DateNaissanceMin,
      'yyyy-MM-dd',
    );
    this.DateNaissanceMax = new Date(
      this.dateDuJour.getFullYear() - 18,
      this.dateDuJour.getMonth(),
      this.dateDuJour.getDate(),
    );
    this.formatDateNaissanceMax = formatDate(
      this.DateNaissanceMax,
      'yyyy-MM-dd',
    );
  }
  public testMethode() {
    return false;
  }
  private situationMatrimoniale(situation: any): any {
    switch (situation) {
      case '1':
        return 'celibataire';
      case '2':
        return 'marie(e)';
      case '3':
        return 'celibataire';
      case '4':
        return 'celibataire';
    }
  }

  enableLoading() {
    this.loading = true;
    (document.body as any).style.cursor = 'wait';
  }

  desableLoading() {
    this.loading = false;
    (document.body as any).style.cursor = 'auto';
  }

  isCodeOrganisme(noOrga: boolean, orga: string): boolean {
    if (!noOrga && !orga) return false;
    return true;
  }

  async validerCoordonnee() {
    //Pour les numéros internationals, +33, 33 et 0033  remplacer par 0
    let telephone: string = this.personne.telephone;
    if (
      telephone.startsWith('+33') ||
      telephone.startsWith('0033') ||
      telephone.startsWith('33')
    ) {
      telephone = '0' + telephone.substring(telephone.indexOf('33') + 2);
      this.personne.telephone = telephone;
    }

    this.enableLoading();
    this.assuree.dateEffet = this.personne.dateDebutContrat;
    if (
      this.personne.compositionFamiliale == '3' ||
      this.personne.compositionFamiliale == '4'
    ) {
      this.assuree.isConjoint = true;
      this.assuree.isEnfants = true;
      this.souscription.situationSouscripteur = this.situationMatrimoniale(
        this.personne.compositionFamiliale,
      );
      this.souscription.cspConjointSouscripteur =
        this.assuree.assureConjoint.csp;
    } else if (this.personne.compositionFamiliale == '2') {
      this.assuree.isEnfants = true;
      this.souscription.situationSouscripteur = this.situationMatrimoniale(
        this.personne.compositionFamiliale,
      );
    } else if (this.personne.compositionFamiliale == '1') {
      this.souscription.situationSouscripteur = this.situationMatrimoniale(
        this.personne.compositionFamiliale,
      );
    }
    this.assuree.eMailRecontacte = this.personne.email;
    this.assuree.telaRappeler = this.personne.telephone;
    this.assuree.ville = this.ville;
    this.assuree.addressAssuree = this.adressePostale;
    this.assuree.addressComplement = this.complementAdresse;
    //Assure principal
    this.assuree.assurePrincipal.nom = this.personne.nom;
    this.assuree.assurePrincipal.prenom = this.personne.prenom;
    this.assuree.assurePrincipal.dateNaissance =
      this.personne.dateNaissanceAssure;

    this.assuree.assurePrincipal.regime = this.personne.regimeSocial;
    this.assuree.assurePrincipal.num_SS = this.numSecuSocial;
    this.assuree.guidUser = this.GUID;
    this.assuree.pwdUser = this.MDP;
    if (this.displayEnfant == true) {
      for (
        let i = 0;
        i < this.personne.enfant.dateNaissanceEnfant.length;
        i++
      ) {
        this.assuree.assureEnfants[i].orga = this.assuree.assurePrincipal.orga;
        this.assuree.assureEnfants[i].noOrga =
          this.assuree.assurePrincipal.noOrga;
        this.assuree.assureEnfants[i].rang = i + 1;
        this.assuree.assureEnfants[i].ayantDroit = this.isCheckedAyantDroit;
        if (this.assuree.assureEnfants[i].ayantDroit == true) {
          this.assuree.assureEnfants[i].ayantDroitDe = this.ayantDroitVia;
          this.assuree.assureEnfants[i].num_SS =
            this.assuree.assurePrincipal.num_SS;
        } else {
          this.assuree.assureEnfants[i].ayantDroitDe = '';
          this.assuree.assureEnfants[i].csp = this.cspEnfant;
          this.assuree.assureEnfants[i].num_SS = this.numeroSsEnfant;
        }
        this.paysLieuNaissanceData['enfants'] = {
          ...this.paysLieuNaissanceData['enfants'],
          [i]: {
            ...this.paysLieuNaissanceData['enfants'][i],
            paysNaissance:
              this.paysLieuNaissanceData['enfants'][i] &&
              this.paysLieuNaissanceData['enfants'][i].paysNaissance
                ? this.paysLieuNaissanceData['enfants'][i].paysNaissance
                : '',
            lieuNaissance:
              this.paysLieuNaissanceData['enfants'][i] &&
              this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                ? this.paysLieuNaissanceData['enfants'][i].lieuNaissance
                : '',
          },
        };
      }
    }
    this.souscription.adresseComplementSouscripteur = this.complementAdresse;
    this.souscription.adresseSouscripteur = this.adressePostale;
    this.souscription.ville = this.ville;
    this.souscription.paysNaissanceSouscripteur = this.paysNaissance;
    this.souscription.lieuNaissanceSouscripteur = this.lieuNaissance;
    this.souscription.bAccepteCondition =
      this.personne.etre_contacte_par_telephone;
    this.souscription.cspSouscripteur = this.assuree.assurePrincipal.csp;
    // this.assuree.assurePrincipal.noOrga = this.noOrga;
    // this.assuree.assurePrincipal.orga = this.codeOrganisme;

    if (this.souscription == null) {
      return false;
    }

    this.paysLieuNaissanceData = {
      ...this.paysLieuNaissanceData,
      lieuNaissance: this.lieuNaissance,
      lieuNaissanceConjoint: this.lieuNaissanceConjoint,
      paysNaissance: this.paysNaissance,
      paysNaissanceConjoint: this.paysNaissanceConjoint,
      enfants: this.paysLieuNaissanceData.enfants
        ? this.paysLieuNaissanceData.enfants
        : [],
    };
    this.eventSouscriptionEmitter.emit(this.souscription);
    sessionStorage.setItem(
      'save.souscription',
      JSON.stringify(this.souscription),
    );
    sessionStorage.setItem('save.assuree', JSON.stringify(this.assuree));
    sessionStorage.setItem(
      'save.paysLieuNaissance',
      JSON.stringify(this.paysLieuNaissanceData),
    );
    var e = await this.beginSubscribe();
    if (e && e.statusCode === 406) {
      this.router.navigate(['/demande-devis']);
      this.errorFraude = true;
      this.desableLoading();
      sessionStorage.removeItem('app.personne');
      sessionStorage.removeItem('tokenData');
      localStorage.removeItem('data.client.personne');
      return;
    }
    this.desableLoading();

    if (this.errorFraude) return;
    await this.setAdhesionFile();
    var assureSouscrire: ValueSubscribe = {
      assures: this.assuree,
      subscribe: this.souscription,
    };
    this.eventEmitter.emit(assureSouscrire);
    if (this.selectedIndex < 3) {
      this.selectedIndex += 1;
      //Send the selected index to the parent component
      this.validerEvent.emit(this.selectedIndex);
    }

    this.validationEtape1 = true;
    this.validationEtape1Event.emit(this.validationEtape1);

    this.desableLoading();

    return false;
  }
  displayVotreConjoint(): boolean {
    if (this.personne.compositionFamiliale == '2') {
      this.ayantDroitVotreConjoit = true;
      return this.ayantDroitVotreConjoit;
    } else {
      this.ayantDroitVotreConjoit = false;
      return this.ayantDroitVotreConjoit;
    }
  }
  RegimeSocialSouscripteur(regime: any): string {
    switch (regime) {
      case '0':
        return 'Régime général';
      case '1':
        return 'Travailleur non salarié';
      case '2':
        return 'Sécurité sociale agricole';
      case '3':
        return 'Alsace-moselle';
      default:
        return '';
        break;
    }
  }
  async setAdhesionFile() {
    let result = await this.souscriptionApi
      .setFicheAdhesion(this.assuree)
      .toPromise()
      .then((response) => response)
      .catch((error) => console.error(error));
    // this.loggerService.log("Set adhesion file  ", result)
    return result;
  }

  async beginSubscribe() {
    return await this.souscriptionApi
      .BeginSubscription(this.souscription)
      .toPromise();
  }
  retour() {
    if (this.selectedIndex > -1) {
      this.selectedIndex -= 1;
    }
  }

  getPaysPlaceHolder(pays: any) {
    return pays && pays.toLowerCase() == 'france'
      ? 'Code postal / Ville'
      : 'Ville';
  }

  changePaysNaissanceConjoint(event: any) {
    this.paysNaissanceConjoint = event.target.value;
  }
  changeLieuNaissanceConjoint(event: any) {
    this.lieuNaissanceConjoint = event.target.value;
  }
  changePaysNaissanceEnfant(event: any, index: number) {
    this.paysLieuNaissanceData.enfants[index].paysNaissance =
      event.target.value;
  }
  changeLieuNaissanceEnfant(event: any, index: number) {
    this.paysLieuNaissanceData.enfants[index].lieuNaissance =
      event.target.value;
  }

  valid: boolean = false;
  isNumSecuSocialeValid(numSecuSocial: string): boolean {
    //verifier dans Numero Insee, si valide alors true
    if (this.numeroInseeService.VerifierINSEE(numSecuSocial)) {
      //(new NumeroINSEE()).NettoyerString(assureEnfant.Num_SS).Insert(13, " ").Insert(10, " ").Insert(7, " ").Insert(5, " ").Insert(3, " ").Insert(1, " ");
      this.valid = true;
      return true;
    } else {
      this.valid = false;
      return false;
    }
  }

  conjointRegimeConverter(): string {
    let regimeChiffre = this.personne.conjointRegimeSociale;
    switch (regimeChiffre) {
      case '0':
        return 'Régime général';
      case '1':
        return 'Travailleur non salarié';
      case '2':
        return 'Sécurité sociale agricole';
      case '3':
        return 'Alsace-moselle';
      default:
        return '';
    }
  }
  enfantRegimeConverter(regimeEnfant: string): string {
    switch (regimeEnfant) {
      case '0':
        return 'Régime général';
      case '1':
        return 'Travailleur non salarié';
      case '2':
        return 'Sécurité sociale agricole';
      case '3':
        return 'Alsace-moselle';
      default:
        return '';
    }
  }

  //Get List of Villes et codes postales
  listAdresses: Adresse[] | any = [];
  listvillesFilteredByCodepostale: Adresse[] | any = [];
  getListVille() {
    this.adresseApi
      .getVillesCodesPostales()
      .toPromise()
      .then((result) => {
        this.listAdresses = result;
        this.filterVillesByCodePostale(this.personne.codePostal);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getListVilleByCP(cp: string) {
    this.adresseApi
      .getVillesByCodePostale(cp)
      .toPromise()
      .then((result) => {
        this.listAdresses = result;
        this.listvillesFilteredByCodepostale = result;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getTitleCodeParrainField() {
    if (this.personne && this.personne.codeParrain) {
      return 'Code parrain';
    }

    return "J'indique le code de mon parrain";
  }

  filterVillesByCodePostale(codePostale: string) {
    if (this.listAdresses.length > 0) {
      //Initialize to null
      this.listvillesFilteredByCodepostale = [];

      for (let item of this.listAdresses) {
        if (item.codePostale == codePostale) {
          let value: Adresse = {
            codePostale: item.codePostale,
            ville: item.ville,
          };
          //Fill table ville filtré
          this.listvillesFilteredByCodepostale.push(value);
          this.villeExist = true;
        }
      }
      //Aucunes villes correspondantes:
      if (!this.villeExist) {
        this.ville = '';
      }
    }
  }
  onClickAyantDroit(): any {
    if (this.displayEnfant == true) {
      for (
        let i = 0;
        i < this.personne.enfant.dateNaissanceEnfant.length;
        i++
      ) {
        if (this.personne.compositionFamiliale == '4') {
          if (
            this.personne.regimeSocial == '0' ||
            this.personne.conjointRegimeSociale == '1'
          ) {
            this.assuree.assureEnfants[i].regime = this.personne.regimeSocial;
          } else if (
            this.personne.regimeSocial == '1' ||
            this.personne.conjointRegimeSociale == '1'
          ) {
            this.assuree.assureEnfants[i].regime = this.personne.regimeSocial;
          } else if (
            this.personne.regimeSocial == '2' ||
            this.personne.conjointRegimeSociale == '2'
          ) {
            this.assuree.assureEnfants[i].regime = '0';
          } else if (
            this.personne.regimeSocial == '3' ||
            this.personne.conjointRegimeSociale == '3'
          ) {
            this.assuree.assureEnfants[i].regime = this.personne.regimeSocial;
          }
        } else if (this.personne.compositionFamiliale == '2') {
          this.assuree.assureEnfants[i].regime = this.personne.regimeSocial;
        } else {
          this.assuree.assureEnfants[i].regime = '';
        }
        return true;
      }
      return true;
    }
  }

  // Origine Theme

  origine!: string;
  originTheme!: any;

  btn_bg = 'linear-gradient(231.74deg, #FF6713 -26.89%, #FF9B00 64.63%)';
  choixRadio_theme = 'th_default';
  avatar = 'souscription/avatar.svg';
  location = 'souscription/location.svg';
  social = 'souscription/Social.svg';
  beneficiaire = 'souscription/beneficiaire.svg';

  themeParams() {
    const origine: string | any = localStorage.getItem('codeOrigin');
    this.origine =
      origine && this.originThemeService.IsTrueOrigine(origine)
        ? origine
        : null;
    this.originTheme = this.originThemeService.GetTheme(this.origine, 1);
    if (this.origine) this.useTheme(this.originTheme);
  }

  useTheme(theme: any) {
    this.choixRadio_theme = theme.choixRadio_theme;
    this.avatar = theme.avatar;
    this.location = theme.location;
    this.social = theme.social;
    this.beneficiaire = theme.beneficiaire;
    this.btn_bg = theme.btn_bg;
  }
}
export interface DialogData {
  email: string;
}

export class CheckboxValidator {
  static checked(control: FormControl) {
    return { checked: control.value };
  }
}
